import React from "react";
import { Modal, Box } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 3,
  textAlign: "center",
};

const YesNoModal = ({
  open,
  onClose,
  onYes,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <p className="yesNoModalText">{title}</p>
        <p className="yesNoModalText">{message}</p>
        <div className="yesNoModalBtns flex justify-around mt-3">
          <button
            // variant="contained"
            color="error"
            onClick={() => {
              onClose();
            }}>
            No
          </button>
          <button
            // variant="contained"
            color="primary"
            onClick={() => {
              onYes();
              onClose();
            }}>
            Yes
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default YesNoModal;
